import { useMemo } from 'react';
import { Platform } from 'react-native';

/**
 * Hook to detect if the current environment is a mobile web browser
 * 
 * This hook is useful for:
 * - Adjusting keyboard behavior on mobile web
 * - Showing/hiding features based on mobile web capabilities
 * - Providing mobile-specific UX patterns
 * 
 * @returns {boolean} True if running on a mobile web browser, false otherwise
 */
export const useIsMobileWeb = (): boolean => {
  return useMemo(() => {
    if (Platform.OS !== 'web' || typeof navigator === 'undefined') {
      return false;
    }

    const userAgent = navigator.userAgent || navigator.vendor || (window as any).opera;

    const isMobile =
      /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Mobile|mobile|CriOS/i.test(
        userAgent
      );

    // iPadOS 13+ uses a desktop-class user agent ("Macintosh") — detect via touch support
    const isIPad =
      /Macintosh/i.test(userAgent) && navigator.maxTouchPoints > 1;

    const isTablet = /iPad|Android.*(?!.*Mobile)/i.test(userAgent);

    return isMobile || isTablet || isIPad;
  }, []);
}; 